
























































































/* eslint-disable */
import Vue, { PropType } from 'vue';
import { WithRefs } from 'vue-typed-refs';

export type Refs = {
  input: HTMLInputElement;
};

/*
 * This component was created to allow the DIV wrapped input to be used within
 * other components such as combobox. This components API is not public.
 */
export default (Vue as WithRefs<Refs>).extend({
  inheritAttrs: false,
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    /**
     * **Assistive text for accessibility.**
     * This object is merged with the default props object on every render.
     * * `spinner`: Assistive text on the spinner.
     */
    assistiveText: {
      type: Object as PropType<{
        spinner: string;
      }>,
      default() {
        return {
          spinner: 'Loading ...',
        };
      },
    },
    /**
     * Class names to be added to the `input` element.
     */
    className: {},
    /**
     * Class names to be added to the outer container `div` of the input.
     */
    containerClassName: {},
    /**
     * Props to be added to the outer container `div` of the input (excluding `containerClassName`).
     */
    containerAttrs: Object,
    /**
     * If true, loading spinner appears inside input on right hand side.
     */
    hasSpinner: Boolean,
    /**
     * Every input must have a unique ID in order to support keyboard navigation and ARIA support.
     */
    id: {
      type: String,
      required: true,
    },
    /**
     * Style object to be added to `input` node
     */
    inputStyle: {
      type: Object as PropType<Partial<CSSStyleDeclaration>>,
    },
    /**
     * Displays the value of the input statically. This follows the static input UX pattern.
     */
    isStatic: Boolean,
    /**
     * This label appears above the input.
     */
    label: String,
    /**
     * Displays the value of the input as read-only. This is used in the inline edit UX pattern.
     */
    readonly: Boolean,
    /**
     * The input value, bound with `v-model`.
     */
    value: [String, Number],
    /**
     * Which UX pattern of input? The default is `base` while other option is `counter`
     */
    variant: {
      type: String,
      validator(val: string) {
        return ['base', 'counter'].includes(val);
      },
      default: 'base',
    },
  },
});
